import React from 'react';
import './CloseButton.css';

/**
 * The app's close button. One component so every panel, sheet and modal
 * dismisses with the same control — before this, each new surface grew its
 * own (round vs square, different sizes, some a bare "×" character).
 *
 * Props:
 *   onClick   (function) - dismiss handler
 *   label     (string)   - aria-label, defaults to "Close"
 *   className (string)   - extra class, for positioning only (e.g. absolute
 *                          placement in a modal). Do not restyle the button.
 */
export const CloseButton = ({ onClick, label = 'Close', className = '' }) => (
  <button
    type="button"
    className={`ui-close-btn${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label={label}
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  </button>
);

export default CloseButton;
